import { createApp } from 'vue';
import { useTheme } from './stores/theme';
import { createPinia } from 'pinia';
import '@fontsource-variable/hanken-grotesk';
import './styles/tokens.css';
import './styles/base.css';
import './styles/ui.css';
import App from './App.vue';
import { router } from './router';
import { vTip } from './lib/tooltip';
import { startPwa } from './lib/pwa';

startPwa();
const pinia = createPinia();
// The chosen theme before anything paints, the login page included.
useTheme(pinia).restore();
createApp(App).use(pinia).use(router).directive('tip', vTip).mount('#app');
